<img [asset]="appLogos[app]" alt="Application logo" type="logo" [theme]="theme.theme$ | async" />
